import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import styled from 'styled-components';

import CircularProgress from '@mui/material/CircularProgress';
import { ThemeProvider } from "@mui/material/styles";
import theme from "../style/theme.js";

import Logo from '../components/Logo.js';
import NavBar from '../components/NavBar.js';
import Footer from '../components/Footer.js';
import Element from '../components/Element.js';

import { apiListeDerniersElements } from '../api.js';

const Page = styled.div`
position:relative;
min-height:100vh;
padding-bottom:300px;
`
const Title = styled.h2`
margin:0 auto;
`

const PageDerniersElements = () => {
    const {typeElement, limit} = useParams()

    const [elements, setElements] = useState(null)
    const [loading, setLoading] = useState(true)
    const [erreur, setErreur] = useState(false)

    useEffect(() => {

        apiListeDerniersElements(typeElement, limit)
        .then(res => {
            setElements(res.reponse)
            setLoading(false)
        })
        .catch(error => {
            console.log(error)
            setLoading(false)
            setErreur(true)
        })
    }, [typeElement, limit])

    return (
        <Page>
            <Logo/>
            <NavBar/>
            <Title>{typeElement} Théatra</Title>
            <p>Derniers éléments modifés</p>
            { elements && elements.map(element => <Element key={element.id} type ={typeElement} elem={element}/>)}
            {loading  && <ThemeProvider  theme={theme}><CircularProgress color="secondary"/><h3>Je charge</h3></ThemeProvider> }
            {erreur  && <h3>J'ai rencontré un problème...</h3> }

            <Footer/>
        </Page>
    )
}
export default PageDerniersElements